/**
 * Authentication helpers
 */

import { isSchedulerAdmin } from '../../constants/hub-groups.js'

const SESSION_DURATION_MS = 12 * 60 * 60 * 1000 // 12 hours in milliseconds
const SESSION_STORAGE_KEY = 'scheduler_user'
const SESSION_TIMESTAMP_KEY = 'scheduler_session_timestamp'

export function getToken() {
  // Token is stored in httpOnly cookie, so we can't access it from JS
  // The API will read it from cookies automatically
  return null
}

export function isAuthenticated() {
  // Check if user data exists and session hasn't expired
  const userData = localStorage.getItem(SESSION_STORAGE_KEY)
  if (!userData) {
    return false
  }
  
  // Check session expiration
  const timestamp = localStorage.getItem(SESSION_TIMESTAMP_KEY)
  if (!timestamp) {
    // Old session without timestamp, consider expired
    clearAuth()
    return false
  }
  
  const sessionAge = Date.now() - parseInt(timestamp, 10)
  if (sessionAge > SESSION_DURATION_MS) {
    // Session expired
    clearAuth()
    return false
  }
  
  return true
}

export function getUser() {
  if (!isAuthenticated()) {
    return null
  }
  
  const userData = localStorage.getItem(SESSION_STORAGE_KEY)
  if (userData) {
    try {
      return JSON.parse(userData)
    } catch {
      clearAuth()
      return null
    }
  }
  return null
}

export function setUser(user) {
  if (user) {
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(user))
    localStorage.setItem(SESSION_TIMESTAMP_KEY, Date.now().toString())
  } else {
    clearAuth()
  }
}

export function clearAuth() {
  localStorage.removeItem(SESSION_STORAGE_KEY)
  localStorage.removeItem(SESSION_TIMESTAMP_KEY)
}

export function isAdmin() {
  return isSchedulerAdmin(getUser())
}

export function getSessionAge() {
  const timestamp = localStorage.getItem(SESSION_TIMESTAMP_KEY)
  if (!timestamp) {
    return null
  }
  return Date.now() - parseInt(timestamp, 10)
}

export function isSessionExpired() {
  const age = getSessionAge()
  if (age === null) {
    return true
  }
  return age > SESSION_DURATION_MS
}
